import React, { useEffect, useState } from "react";
import {
  TextField,
  InputAdornment,
  styled,
  Box,
  Typography,
} from "@mui/material";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import VerifyOtp from "./VerifyOtp";
import InputField from "./InputField";
import { formatTime } from "../../utils/formatTime";
import { api, post } from "../../utils/api";

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    height: "40px",
  },
}));

const PhoneInputField = ({
  title,
  value,
  fieldName,
  placeholder,
  countryCode,
  setFormData,
  formData,
  setErrors,
  errors,
}) => {
  // console.log(verify,verifybtn,verify.phoneMsg,"for the phoneInput")
 

  const handleInputChange = (event) => {
    const inputValue = event.target.value;

    // Allow only numeric input and restrict to 10 digits
    if (/^\d{0,10}$/.test(inputValue)) {
      handlePhoneChange(event);
    }
  };

  const handlePhoneChange = (e) => {
    const { value } = e.target;

    // Reset the icons and error state when phone changes
       setErrors((prevErrors) => ({
      ...prevErrors, // Preserve existing errors
      phone: "",
      contactPersonMobile: "",
    }));

    // Ensure country code is selected before validating the phone number
    if (formData?.countryCode === "") {
      setErrors((prevErrors) => ({
        ...prevErrors, // Preserve existing errors
        // phone: "Country Code is required. Please Select Country",
        phone: "Please Select Country",
        contactPersonMobile: "Please Select Country",
      }));
      return;
    }

   
    // Validate if the number is numeric and doesn't exceed 10 digits
    if (!/^\d{0,10}$/.test(value)) {
      setErrors((prevErrors) => ({
        ...prevErrors, // Preserve existing errors
        phone: "Please Enter 0 - 9 digit only.", // Clear only the email error
        contactPersonMobile: "Please Enter 0 - 9 digit only.",
      }));
      return; // If the value is not numeric or exceeds 10 digits, do nothing
    }

    // Update formData only when phone number is valid
    setFormData((prevFormData) => ({
      ...prevFormData,
      phone: value, // Update the mobile number as a string
    }));

   
  };

 
  return (
    <Box>
      <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
        {title}
      </Typography>
      <CustomTextField
        variant="outlined"
        fullWidth
        value={value || ""}
        placeholder={placeholder}
        // disabled={!countryCode}
        onChange={handleInputChange} // Use the new input change handler
        InputProps={{
          maxLength: 10, // Visual limit
          inputMode: "numeric",
          pattern: "[0-9]*",
        //   endAdornment: showIcon && <TaskAltIcon sx={{ color: "green" }} />,
          startAdornment: (
            <InputAdornment
              position="start"
              sx={{ display: "flex", alignItems: "center" }}
            >
              {/* Render placeholder or countryCode */}
              {countryCode ? (
                <div
                  style={{
                    width: "40px",
                    marginRight: "8px",
                    fontWeight: "bold",
                  }}
                >
                  {countryCode}
                </div>
              ) : (
                <div
                  style={{
                    width: "40px",
                    marginRight: "8px",
                    color: "#B0B0B0",
                  }}
                >
                  {"code"}
                </div>
              )}
              {/* Vertical Line */}
              <div
                style={{
                  borderRight: "1px solid #000",
                  height: "24px",
                  marginRight: "8px",
                }}
              />
            </InputAdornment>
          ),
        }}
      />
      {errors && (
        <Typography variant="body2" color="#D34040">
          {errors}
        </Typography>
      )}
    </Box>
  );
};

export default PhoneInputField;
